<template>
  <div class="event-board-list-wrap">
    <div class="mypooq-list">
      <my-pooq-empty-list v-if="!isLoading && eventBoardList.length === 0" info-text="이벤트 당첨자 발표가 없습니다."></my-pooq-empty-list>
      <div class="event-list-wrap"
           v-infinite-scroll="loadMore"
           :infinite-scroll-distance="250"
           :infinite-scroll-throttle-delay="200"
           :loading="!isLoading"
      >
        <template v-if="eventBoardList.length > 0">
          <div v-for="(board, index) in eventBoardList" :key="index" class="event-list">
            <div class="event-winner-list">
              <a href="#" @click.prevent="()=>goBoardDetail(board)">
                <strong class="event-tit02">{{board.eventtitle}}</strong>
                <span class="event-text">
                  <span>발표</span>
                  <span class="title-dot"></span>
                  <span>{{board.announcementdate}}</span>
                </span>
              </a>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import MyPooqEmptyList from '@/components/lnb/mypooq/MyPooqEmptyList'
import { EventService } from '@/common/api/api.service'
import { infiniteScroll } from '@/common/directives'
import { get } from 'lodash'
import { isApp } from '@/common/util/common'
export default {
  name: 'EventBoardList',
  components: {
    MyPooqEmptyList
  },
  directives: {
    infiniteScroll
  },
  data () {
    return {
      eventBoardList: [],
      offset: 0,
      limit: 20,
      endOfList: false,
      isLoading: true
    }
  },
  methods: {
    goBoardDetail (board) {
      if (isApp()) {
        location.href = `captvpooq://customer/event_board_view?eventId=${board.eventid}`
      } else {
        this.$router.push(`/event/board/${board.eventid}`)
      }
    },
    loadMore () {
      if (this.endOfList) return
      this.setData()
    },
    setData () {
      this.isLoading = true
      EventService.getEventNotice({
        offset: this.offset,
        limit: this.limit
      }).then(({ data }) => {
        const resList = get(data, 'list', [])
        this.endOfList = resList.length === 0
        this.offset += this.limit
        this.eventBoardList = this.eventBoardList.concat(resList)
        this.isLoading = false
      })
    }
  }
}
</script>

<style scoped>
  .event-board-list-wrap {
    width: 100%;
    height: 100%;
    /*overflow-y: scroll;*/
    /*overflow-scrolling: touch;*/
    /*-webkit-overflow-scrolling: touch;*/
  }
  .event-board-list-wrap::-webkit-scrollbar{
    display: none
  }
  .event-winner-list {
    padding: 15px 0;
    border-bottom: 1px solid #2f2f2f;
    margin: 0 15px;
  }
  /*.event-list {*/
  /*  padding-bottom: 12px;*/
  /*}*/
  .event-winner-list a {
    display: block;
    width: 100%;
  }
  .event-tit02 {
    font-size: 14px;
  }
  .event-tit, .event-tit02 {
    display: block;
    color: #fff;
  }
  h1, h2, h3, h4, h5, h6, strong {
    font-weight: 400;
  }
  .event-winner-list .event-text {
    padding: 0;
  }
  .event-text {
    font-size: 12px;
    color: #a5a5a5;
    padding: 0 10px 3px;
  }
  .event-list-wrap {
    position: relative;
    width: 100%;
    height: 100%;
  }
  .event-list {
    position: relative;
    width: 100%;
  }
  .title-dot{
    display: inline-block;
    vertical-align: middle;
    width: 4px;
    height: 4px;
    margin: 0 3px;
    border-radius: 50%;
    border: 1px solid #888;
  }
</style>
